module.exports = __webpack_public_path__ + "static/media/r50.db694ae0.jpg";